// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, enumOf } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsGetWhatsAppDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      subscription_group_name: string,
      is_archived: boolean,
      id: string,
      phone_number: objectOf({
        phone_number: string,
        display_name: string,
        status: enumOf("active", "inactive", "deleted"),
      }),
    })
  ),
});
